export default __webpack_public_path__ + "static/media/ToroOpen.b2b70854.jpg";